import type { AtlasApiTyped } from './types';

import './setup';
import { atlasApiRoot } from './root';

export const atlas = atlasApiRoot as AtlasApiTyped;
